export * from './AcademicAssessments';
export * from './ApplicantParticulars';
export * from './createDsrcAssessment';
export * from './DeclarationAssessments';
export * from './MeritAssessments';
export * from './PublicationAssessments';
export * from './ScoresOnApplicant';
export * from './updateDsrcAssessment';
export * from './validateDsrcAssessment';
export * from './types';
